/**
 * Created by Bart Decorte
 * Date: 2019-07-17
 * Time: 10:55
 */
import EpochColumn from "./EpochColumn";

class TimeColumn extends EpochColumn {

  constructor(params) {
    params.format = 'H:i:S'
    params.selector = '.js-column-time';
    params.enableTime = true;
    params.noCalendar = true;
    super(params);
  }

}

export default TimeColumn;



// WEBPACK FOOTER //
// ./resources/assets/js/columns/TimeColumn.js